import {
  SCHOOL_ACTIVATION_STATS_URL,
  TEAM_INACTIVE_STUDENTS_URL,
} from "../helpers/routes";
import { getMultipartParams, handleResponse } from "../helpers/validate";
import notice from "../../utils/notice";

// TZ-786 Step 5 admin UI: read-side CRUD for activation tracking.
// Two endpoints, both GET-only — there's no write surface here, this
// is purely "who's signed in vs not" reporting on top of the rosters
// uploaded in Step 4 (TZ-789).
//
// Visibility is enforced server-side (see Api::V3::ActivationController
// can_see_school? / can_see_named_list?) — the UI calls the endpoint
// for whatever school the caller has selected and the API decides
// whether to return the data or 403. We surface errors via notice()
// uniformly so a coach poking at a school they aren't on gets a
// readable message instead of a silent empty state.

export const getSchoolActivationStats = (setterFunction, schoolId) =>
  fetch(SCHOOL_ACTIVATION_STATS_URL(schoolId), getMultipartParams("GET"))
    .then((res) => handleResponse(res))
    .then((json) => {
      setterFunction(json);
      return json;
    })
    .catch((e) => {
      notice("Error loading activation stats");
      console.error(e.errors || e);
      throw e;
    });

export const getInactiveStudents = (setterFunction, teamId) =>
  fetch(TEAM_INACTIVE_STUDENTS_URL(teamId), getMultipartParams("GET"))
    .then((res) => handleResponse(res))
    .then((json) => {
      setterFunction(json);
      return json;
    })
    .catch((e) => {
      notice("Error loading inactive students");
      console.error(e.errors || e);
      throw e;
    });
